import { render, staticRenderFns } from "./jRadio.vue?vue&type=template&id=b3aef6f4&scoped=true&"
import script from "./jRadio.vue?vue&type=script&lang=js&"
export * from "./jRadio.vue?vue&type=script&lang=js&"
import style0 from "./jRadio.vue?vue&type=style&index=0&id=b3aef6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aef6f4",
  null
  
)

export default component.exports